import { CalendarTranslateService } from './../../services/calendarTranslate.service';
import { CheckDateService } from './../../../../services/check-date/check-date.service';
import { Component, OnInit, OnChanges, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-kv-calendar',
  templateUrl: './kv-calendar.component.html',
  styleUrls: ['./kv-calendar.component.css']
})
export class KvCalendarComponent implements OnInit, OnChanges {
  @Input() inputName: string;  // required
  @Input() formData: FormGroup; // required

  @Input() yearRange = '1900:2099';
  @Input() maxDate: Date;
  @Input() minDate: Date;
  @Input() defaultDate: Date;
  @Input() defaultValue: Date;
  @Input() disabled = false;

  // In caso di Calendari Multipli per selezione Date in Successione
  @Input() startDateSelector = false;   // true se selettore Data Iniziale
  @Input() endDateSelector = false;     // true se selettore Data Finale
  @Input() startDateInputName: string;  // required per selettore Data Finale
  @Input() endDateInputName: string;    // required per selettore Data Iniziale
  @Input() startDateCalendar: any;      // required se selettore Data Finale
  @Input() endDateCalendar: any;        // required per selettore Data Iniziale

  @ViewChild('calendar', {read: ElementRef}) calendarRef: ElementRef;
  @ViewChild('calendar') calendar: any;

  dateStartIssue = false;
  dateEndIssue = false;

  constructor(private checkDateService: CheckDateService, public srvCalendarTranslate: CalendarTranslateService) { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formData && this.calendarRef && this.calendarRef.nativeElement.children[0].children[0]) {
      this.calendarRef.nativeElement.children[0].children[0].value = changes.formData.currentValue.controls[this.inputName].value;
    }
  }

  /**
   * Aggiorna i dropdown per la selezione di mese ed anno.
   * Risolve il bug del mancato aggiornamento in caso di inserimento testuale della data.
   * @param calendar
   * @param form
   */
  getMonthAndYearFromInput(calendar, form) {
    if (form.value[this.inputName]) {
      calendar.currentYear = form.value[this.inputName].getFullYear();
      calendar.currentMonth = form.value[this.inputName].getMonth();
    }
  }

  /**
   * Verifica che la data iniziale non sia successiva a quella finale
   * @param calendar
   * @param form
   */
  dateStartChanged(calendar, form: FormGroup) {
    form.controls[this.inputName].setValue(calendar.value);
    this.checkDateService.checkStartDate(form.controls[this.inputName], form.controls[this.endDateInputName])
    .subscribe(res => {
      this.dateStartIssue = res.dateStartIssue;
      this.endDateCalendar.minDate = res.dateEndMin;
      this.getMonthAndYearFromInput(calendar, form);
      if (this.dateStartIssue) {
        this.dateIssueHandler(calendar, form);
      }
    });
  }

  /**
   * Verifica che la data finale non sia precedente a quella iniziale
   * @param calendar
   * @param form
   */
  dateEndChanged(calendar, form: FormGroup) {
    form.controls[this.inputName].setValue(calendar.value);
    this.checkDateService.checkEndDate(form.controls[this.startDateInputName], form.controls[this.inputName])
    .subscribe(res => {
      this.dateEndIssue = res.dateEndIssue;
      this.startDateCalendar.maxDate = res.dateStartMax;
      this.getMonthAndYearFromInput(calendar, form);
      if (this.dateEndIssue) {
        this.dateIssueHandler(calendar, form);
      }
    })
  }

  dateIssueHandler(calendar, form: FormGroup) {
    form.controls[this.inputName].setValue('');
    calendar.value = '';
    calendar.inputFieldValue = '';
    this.calendarRef.nativeElement.children[0].children[0].blur();
    this.calendarRef.nativeElement.children[0].children[2].hidden = true;
  }

  dateChangeHandler(calendar, form: FormGroup, event?: any) {
    if (this.minDate && event && event.target.value.length === 10) {
      const date = moment(event.target.value, this.srvCalendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase());
      let minDate: any = moment(this.minDate).format(this.srvCalendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase());
      minDate = moment(minDate, this.srvCalendarTranslate.pcalendarTranslate.dateFormatFilter.toUpperCase());
      const dateBeforeMinDate = moment(date).isBefore(minDate);
      if (dateBeforeMinDate) {
        this.dateIssueHandler(calendar, form);
      }
    }
    if (this.startDateSelector) {
      this.dateStartChanged(calendar, form)
    } else if (this.endDateSelector) {
      this.dateEndChanged(calendar, form)
    } else {
      form.controls[this.inputName].setValue(calendar.value);
      this.getMonthAndYearFromInput(calendar, form);
    }
  }

  mouseClickHandler(event) {
    event.preventDefault();
  }

  clearInputField() {
    this.calendarRef.nativeElement.children[0].children[0].value = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kv-calendar/kv-calendar.component.ts